/**
 * Wibblewabble app-level Backstage theme (unified v4 + v5).
 *
 * Sets global palette, fonts and page-header treatment so *all* of Backstage
 * (and anything we haven't replaced yet) adopts the wibblewabble brand. Our own
 * product pages layer a dedicated MUI v5 theme on top for pixel fidelity.
 */
import {
  createUnifiedTheme,
  genPageTheme,
  palettes,
  shapes,
} from '@backstage/theme';
import { color, font } from './tokens';

export const wwUnifiedTheme = createUnifiedTheme({
  fontFamily: font.sans,
  palette: {
    ...palettes.light,
    primary: {
      main: color.primary,
      dark: color.primaryHover,
      light: color.primaryTint,
      contrastText: '#FFFFFF',
    },
    secondary: { main: color.onTint, light: color.primaryTint },
    success: { main: color.success.main, dark: color.success.text, light: color.success.tint },
    warning: { main: color.warning.main, dark: color.warning.text, light: color.warning.tint },
    error: { main: color.danger.main, dark: color.danger.text, light: color.danger.tint },
    info: { main: color.info.main, dark: color.info.text, light: color.info.tint },
    text: { primary: color.ink, secondary: color.secondary, disabled: color.muted },
    divider: color.border,
    background: { default: color.bg, paper: color.surface },
    // Backstage sidebar/navigation chrome, tinted to the brand band.
    navigation: {
      ...palettes.light.navigation,
      background: color.brandInk,
      indicator: color.primary,
      color: 'rgba(255,255,255,.72)',
      selectedColor: '#FFFFFF',
      navItem: { hoverBackground: 'rgba(255,255,255,.08)' },
    },
  },
  defaultPageTheme: 'home',
  pageTheme: {
    home: genPageTheme({ colors: [color.brandInk, color.primary], shape: shapes.wave }),
  },
  typography: {
    fontFamily: font.sans,
    htmlFontSize: 16,
    h1: { fontSize: 30, fontWeight: 600, marginBottom: 0 },
    h2: { fontSize: 24, fontWeight: 600, marginBottom: 0 },
    h3: { fontSize: 21, fontWeight: 600, marginBottom: 0 },
    h4: { fontSize: 17, fontWeight: 600, marginBottom: 0 },
    h5: { fontSize: 15, fontWeight: 600, marginBottom: 0 },
    h6: { fontSize: 13.5, fontWeight: 600, marginBottom: 0 },
  },
});
